/*global jQuery, SimpleBar, YT, DM, vidible*/
(function ($) {
    'use strict';

    $.fn.topVideos = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('topVideos');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.topVideos.defaults,
                    typeof option === 'object' && option
                );

                $element.data('topVideos', (ctrl = new TopVideos(this, opts)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.topVideos.defaults = { };

    function TopVideos(element, options) {
        this.init(element, options);
    }

    TopVideos.lastUid = 0;

    TopVideos.prototype = {
        constructor: TopVideos,

        // Properties
        uid: 0, // Unique id attached to each top video instance
        $playbackArea: null,
        $videosList: null,
        simpleBar: null,

        // Contains current youtube player if there is such
        youtubePlayer: null,
        vidiblePlayer: null,
        autoClickDirty: false,
        dailyMotionPlayer: null,

        // Methods
        init: function (element, options) {
            this.uid = TopVideos.lastUid++;
            this.options = options;
            this.$element = $(element);
            this.$playbackArea = this.$element.find('.top-videos__play');
            this.$videosList = this.$element.find('.top-videos__list__content');
            this.simpleBar = new SimpleBar(this.$videosList[0]);

            // Create reused method closures
            this._onYoutubeStateChange = this._onYoutubeStateChange.bind(this);
            this._onVidibleVideoEnd = this._onVidibleVideoEnd.bind(this);
            this._onDailyMotionEnd = this._onDailyMotionEnd.bind(this);
            this._onEmbedLoaded = this._onEmbedLoaded.bind(this);
            this._onWindowBlur = this._onWindowBlur.bind(this);
            this._hookYoutube = this._hookYoutube.bind(this);
            this._hookDailyMotion = this._hookDailyMotion.bind(this);
            this._trackVideo.cardLinkClick = this._trackVideo.cardLinkClick.bind(this);

            // Handle resize logic
            this._validateSize();
            $(window).on('resize', this._validateSize.bind(this));

            // Listeners
            this.$videosList.on('click', '.card a', this._onPlayVideoClick.bind(this));
            this.$videosList.on('wheel', this._onMouseWheel.bind(this));
            this.$element.on('click', '[data-top-videos]', this._onDataAction.bind(this));

            // Detect player clicks.
            window.addEventListener('blur', this._onWindowBlur); // When there's an iframe that's the only way to detect
            // Capture phase increases our chances of catching the click before the content
            this.$playbackArea[0].addEventListener('click', this._onEmbedClick.bind(this), true);

            this._activateCard('first', false);
        },

        // Cleans global listeners
        dispose: function() {
            if (this.vidiblePlayer) {
                this.vidiblePlayer.removeEventListener(vidible.VIDEO_END, this._onVidibleVideoEnd);
                this.vidiblePlayer = null;
            }

            if (this.dailyMotionPlayer) {
                this.dailyMotionPlayer.removeEventListener('end', this._onDailyMotionEnd);
                this.dailyMotionPlayer = null;
            }

            this.youtubePlayer = null;
            window.removeEventListener('blur', this._onWindowBlur);
        },

        isNarrow: function() {
          return this.$element.hasClass('top-videos--narrow');
        },

        /**
         * @param {string} url
         * @param {boolean} autoPlay
         */
        playVideo: function (url, autoPlay) {
            var $playbackArea = this.$playbackArea;

            if (autoPlay) {
                url += url.lastIndexOf('?') >= 0 ? '&autoplay=1' : '?autoplay=1';
            }

            $playbackArea.data('video-meta', {
               url: url, autoPlay: autoPlay
            });

            $.get(url).then(function (content) {
                $playbackArea.css('opacity', 0);
                $playbackArea.html(content).promise().done(this._onEmbedLoaded);
                $playbackArea.animate({opacity: 1});
            }.bind(this));
        },

        /**
         * Hooks a vidible player. Called externally from vidible.js
         */
        hookVidible: function(player) {
            this.vidiblePlayer = player;
            this.vidiblePlayer.addEventListener(vidible.VIDEO_END, this._onVidibleVideoEnd);
        },

        /** @private */
        _onEmbedLoaded: function() {
            var $playbackArea = this.$playbackArea;
            var $youtubePlayer = $playbackArea.find('#ytplayer');
            var $iframe = $playbackArea.find('iframe');

            this.youtubePlayer = null;
            this.vidiblePlayer = null;
            this.dailyMotionPlayer = null;

            if ($youtubePlayer.length) {
                hpYoutube.apiReady().then(this._hookYoutube);
            } else if ($iframe.filter('[src*="video.huffingtonpost.it"]').length) {
                console.log('italy video detected');
                /** @type HTMLIFrameElement */
                //var frame = $playbackArea.find('iframe')[0];
            } else if ($iframe.data('provider') === 'dailymotion') {
                hpDailyMotion.apiReady().then(this._hookDailyMotion);
            }
        },

        /** @private */
        _hookYoutube: function() {
            var $youtubePlayer = this.$playbackArea.find('#ytplayer');

            // Change id to avoid duplicates
            var newPlayerId = 'top-video-youtube-' + this.uid;
            $youtubePlayer.prop('id', newPlayerId);

            this.youtubePlayer = new YT.Player(newPlayerId, {
                events: {
                    onStateChange: this._onYoutubeStateChange
                }
            });
        },

        /** @private */
        _hookDailyMotion: function() {
            var $dmPlayer = this.$playbackArea.find('#dmPlayer');

            // Change id to avoid duplicates
            var newPlayerId = 'top-video-dm-' + this.uid;
            $dmPlayer.prop('id', newPlayerId);

            var videoId = $dmPlayer.data('video-id');
            var autoplay = $dmPlayer.data('autoplay');

            this.dailyMotionPlayer = DM.player($dmPlayer[0], {
                video: videoId,
                params: {
                    autoplay: autoplay
                }
            });

            this.dailyMotionPlayer.addEventListener('end', this._onDailyMotionEnd);
        },

        /** @private */
        _onVidibleVideoEnd: function() {
            this._autoPlayNext();
        },

        /** @private */
        _onDailyMotionEnd: function() {
            this._autoPlayNext();
        },

        /**
         * @param {{data: string}} newState Youtube player state
         * @private
         */
        _onYoutubeStateChange: function(newState) {
            if (newState.data === YT.PlayerState.ENDED) {
                this._autoPlayNext(); // Play the next youtube video
            }
        },

        _autoPlayNext: function() {
            var videoUrl = this._activateCard('next', true);

            if (videoUrl) {
                this._trackVideo.autoPlayNext(videoUrl);
            }
        },

        /** @private */
        _validateSize: function() {
            var $element = this.$element;
            var elementWidth = this.$element.outerWidth();

            if (elementWidth > 1024) {
                // Wide version
                $element.removeClass('top-videos--narrow').addClass('top-videos--wide');
            } else {
                // Narrow version
                $element.removeClass('top-videos--wide').addClass('top-videos--narrow');
            }
        },

        /** @private */
        _onPlayVideoClick: function (event) {
            event.preventDefault();
            var videoUrl = this._activateCard($(event.target).closest('.card'), true);

            if (videoUrl) {
                this._trackVideo.afterClick(videoUrl);
                this._trackVideo.cardLinkClick(event.target);
            }

            return false;
        },

        _onMouseWheel: function(event) {
            if (this.isNarrow()) {
                // Turn on horizontal scrolling with mouse wheel
                var delta = event.originalEvent.deltaY;
                var contentElement = this.simpleBar.getContentElement();

                contentElement.scrollLeft += delta;
                event.preventDefault();
                event.stopPropagation();
            }
        },

        _onDataAction: function(e) {
            var action =  $(e.currentTarget).data('top-videos');

            switch (action) {
                case 'prev':
                    this.simpleBar.getContentElement().scrollLeft -= 50;
                    break;
                case 'next':
                    this.simpleBar.getContentElement().scrollLeft += 50;
                    break;
            }
        },

        /**
         * @param {string|jQuery} element
         * @returns jQuery
         * @private
         */
        _elementToCard: function(element) {
            switch (element) {
                case 'first':
                    return this.$cards.first();
                case 'next':
                    return this.$activeCard.next('.card');
                default:
                    return $(element).closest('.card');
            }
        },

        get $activeCard() {
            return this.$videosList.find('.card--active');
        },

        get $cards() {
            return this.$videosList.find('.card');
        },

        /**
         * @param element
         * @param {boolean} autoPlay
         * @return {string} video url
         * @private
         */
        _activateCard: function (element, autoPlay) {
            var $card = this._elementToCard(element);
            var videoUrl = null;

            if ($card.length) {
                var $link = $card.find('a').first();
                videoUrl = $link.attr('href');

                $card.siblings().removeClass('card--active');
                $card.addClass('card--active');

                autoPlay = autoPlay !== false;

                if (autoPlay) {
                    // If a video is on autoplay mode scroll it into view
                    $card[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
                }

                this.playVideo('/video-embed' + videoUrl, autoPlay);
            } else {
                // Last card was reached. Remove play status and do nothing
                this.$cards.removeClass('card--active');
            }

            this._verifyActiveIndex();
            return videoUrl;
        },

        _verifyActiveIndex: function() {
            var cardIndex = this.$cards.index(this.$activeCard);
            var $element = this.$element;

            if (cardIndex === 0) {
                $element.removeClass('top-videos--last').addClass('top-videos--first');
            } else if (cardIndex <= 0 || cardIndex === this.$cards.length - 1) {
                $element.removeClass('top-videos--first').addClass('top-videos--last');
            } else {
                $element.removeClass('top-videos--first top-videos--last');
            }
        },

        /** @private */
        _onEmbedClick: function(e) {
            if (!this.autoClickDirty) {
                /** @type {{url: string, autoPlay: boolean}} */
                var videoMeta = this.$playbackArea.data('video-meta');

                if (!videoMeta.autoPlay) {
                    // Video didn't start automatically when loaded. Track start on click.
                    // It was a video without autoPlay user clicked manually to start it
                    this._trackVideo.afterClick(videoMeta.url);
                }

                setTimeout(function () {
                    // Keep the flag raised for some time to avoid duplicate tracking if both
                    // _onEmbedClick and _onWindowBlur occur at the same time.
                    this.autoClickDirty = false;
                }.bind(this), 100);
            }
        },

        _onWindowBlur: function(e) {
            if (!this.autoClickDirty && document.activeElement instanceof HTMLIFrameElement) {
                var $embedFrame = this.$playbackArea.find('iframe');

                if ($embedFrame.length && $embedFrame[0] === document.activeElement) {
                    this._onEmbedClick(e);
                }
            }
        },

        /** @private */
        _trackVideo: {
            afterClick: function trackVideo_afterClick(videoUrl) {
                console.log('Top Videos - after click:', videoUrl);

                if (window.RapidInstance) {
                    window.RapidInstance.beaconEvent('simple', {
                        _R: videoUrl,
                        expn: 'click-play',
                        navtype: 'client'
                    }, 'top-videos');
                }
            },
            autoPlayNext: function trackVideo_autoPlayNext(videoUrl) {
                console.log('Top Videos - auto play next:', videoUrl);

                if (window.RapidInstance) {
                    window.RapidInstance.beaconEvent('simple', {
                        _R: videoUrl,
                        expn: 'auto-play',
                        navtype: 'client'
                    }, 'top-videos');
                }
            },
            cardLinkClick: function trackVideo_cardLinkClick(linkEl) {
                var $link = $(linkEl);
                var $card = $link.closest('.card');
                var pValue = this.$cards.index($card);
                var $rapidSec = this.$element.closest('[data-rapid-sec]');
                var rapidSec, secData;

                if ($rapidSec.length) {
                    try {
                        secData = JSON.parse($rapidSec.attr('data-rapid-sec'));
                    } catch (e) {
                        secData = null;
                    }

                    if (secData) {
                        // Extract the rapid section key
                        for (var key in secData) {
                            if (secData.hasOwnProperty(key)) {
                                rapidSec = key;
                                break;
                            }
                        }
                    }
                }

                if (window.RapidInstance) {
                    window.RapidInstance.beaconClick(
                        rapidSec, $link.text(), pValue, {
                            sub_sec: 'top-videos', cpos: pValue, pos: 1
                        }
                    );
                }
            }
        }
    };

    // Hook all top videos modules on the page
    $('.top-videos').topVideos();
})(jQuery);
